import { AppState } from '@redux/types';
import { CountriesState } from '@redux/reducers/countries/types';

export function _isLoadingCountry(state: AppState): boolean {
  return state.country.loading;
}
export function _getUserLocationCountry(state: AppState): CountriesState {
  return state.country.userLocation;
}
